import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ModalDialog from 'src/components/ModalDialog';
import { useStoreUnitActions } from 'src/redux/helpers';
import SolutionAssetConfigCodeBlock from './SolutionAssetConfigCodeBlock';
import solutionsStore, {
  useAssetConfigFileData,
  useDeviceConfigFileData,
} from '../../redux';
import {
  SolutionAssetConfigListItem,
  SolutionDeviceConfigItem,
} from '../../types';

type Props = {
  item?: SolutionAssetConfigListItem;
  open: boolean;
  onClose: () => void;
};

function SolutionAssetConfigViewModal({ item, open, onClose }: Props) {
  const { solutionId } = useParams();
  const actions = useStoreUnitActions(solutionsStore);
  const [data, loading] = useAssetConfigFileData();
  const name: any = item?.fileName;

  useEffect(() => {
    actions.assetConfigFile({
      solutionId,
      twinId: item?.twinId,
      fileName: name,
    });
  }, [item?.twinId]);

  return (
    <ModalDialog
      title={name}
      open={open}
      onClose={onClose}
      loading={loading}
      showCancelBtn={false}
      showConfirmBtn={false}
      maxWidth="md"
      fullWidth
    >
      <SolutionAssetConfigCodeBlock data={data !== null ? data : {}} />
    </ModalDialog>
  );
}

export default SolutionAssetConfigViewModal;
